import { render } from "./ChatSessions.vue?vue&type=template&id=37f72d5c&scoped=true"
import script from "./ChatSessions.vue?vue&type=script&lang=js"
export * from "./ChatSessions.vue?vue&type=script&lang=js"

import "./ChatSessions.vue?vue&type=style&index=0&id=37f72d5c&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f72d5c"]])

export default __exports__